// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"FollowButton-module__actionButton___LB7p7","smallFollowButton":"FollowButton-module__smallFollowButton___2bUqC"};